import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/LoginView.vue'
import QuestionnaireListView from '@/views/QuestionnaireListView.vue'
import QuestionnaireResultsView from '@/views/QuestionnaireResultsView.vue'
import QuestionnaireView from '@/views/QuestionnaireView.vue'
import ResourceCatalogView from '@/views/ResourceCatalogView.vue'
import ResourceRecommendedView from '@/views/ResourceRecommendedView.vue'
import StatisticsView from '@/views/StatisticsView.vue'
import ConfigurationView from '@/views/ConfigurationView.vue'
import ErrorTesterView from '@/views/ErrorTesterView.vue'
import NotFoundView from '@/views/NotFoundView.vue'
import AboutView from '@/views/AboutView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      props: true
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
    },
    {
      path: '/questionnaires',
      name: 'questionnaireList',
      component: QuestionnaireListView,
    },
    {
      path: '/questionnaire/:id',
      name: 'questionnaireView',
      component: QuestionnaireView,
      props: ({params}) => ({id: Number.parseInt(params.id as string, 10) || 0})
    },
    {
      path: '/questionnaire/:id/results',
      name: 'questionnaireResults',
      component: QuestionnaireResultsView,
      props: ({params}) => ({id: Number.parseInt(params.id as string, 10) || 0})
    },
    {
      path: '/resources/all',
      name: 'resourcesCatalog',
      component: ResourceCatalogView
    },
    {
      path: '/resources/recommended',
      name: 'resourcesRecommended',
      component: ResourceRecommendedView
    },
    {
      path: '/stats',
      name: 'stats',
      component: StatisticsView
    },
    {
      path: '/configuration',
      name: 'configuration',
      component: ConfigurationView
    },
    {
      path: '/error-test',
      name: 'error-test',
      component: ErrorTesterView
    },
    {
      path: '/about',
      name: 'about',
      component: AboutView
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: NotFoundView
    }
  ],
})

export default router
